export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'
export const competitionId = {
  DEV:{
    'es-CO' : 435,
    'es-PR' : 502,
    'es-CL' : 503,
  },
  PDN: {
    'es-CO' : 481,
    'es-PR' : 561,
    'es-CL' : 562,
  }
}[ENV][LOCALE]
export const concourseId=competitionId;

export const costActivity = 30
export const costHelpActivity = 10
